
/**
 * Semper Fi Flag Supply theme tweaks
 * - Hide "Subscribe" from nav (leave Contact)
 * - Force Contact to /pages/contact#contact
 * - Force Shop Plans / Choose Plans to anchor to plans CTA
 * - Smooth-scroll to anchors with header offset
 * - Hide the one-time fee product from grids if it appears
 */
(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const smoothScrollTo = (el) => {
    if (!el) return;
    const headerH = (() => {
      const v = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      const n = parseInt(v.replace('px', ''), 10);
      return Number.isFinite(n) ? n : 90;
    })();

    const top = el.getBoundingClientRect().top + window.scrollY - headerH - 12;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const applyNavTweaks = () => {
    // 1) Remove any nav items that say "Subscribe"
    document.querySelectorAll('a').forEach((a) => {
      const t = norm(a.textContent);
      if (t === 'subscribe') {
        const li = a.closest('li');
        if (li) li.remove();
        else a.remove();
      }
    });

    // 2) Contact button/link: always to contact page + form anchor
    document.querySelectorAll('a').forEach((a) => {
      const t = norm(a.textContent);
      if (t === 'contact us' || t === 'contact') {
        a.setAttribute('href', '/pages/contact#contactus');
      }
    });

    // 3) "Shop Plans" / "Choose Plans" should go to the Plans CTA section
    document.querySelectorAll('a').forEach((a) => {
      const t = norm(a.textContent);
      const href = (a.getAttribute('href') || '').trim();

      const isPlansText = t === 'shop plans' || t === 'choose plans';
      const isPlansHref = /\/pages\/plan\b/i.test(href) || /\/pages\/plans\b/i.test(href);

      if (isPlansText || isPlansHref) {
        a.setAttribute('href', '/pages/plan#plans-cta');
      }
    });

    // (intentionally no-op)
  };

  const hideFeeProductCards = () => {
    const selectors = [
      'a[href*="one-time-purchase-fee"]',
      'a[href*="onetime-purchase-fee"]',
      'a[href*="purchase-fee"]',
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((a) => {
        const card = a.closest('.product-card, .card, .grid__item, li');
        if (card) card.style.display = 'none';
      });
    });
  };

  const handleInitialHash = () => {
    const h = window.location.hash || '';
    if (!h) return;

    const id = h.replace('#', '');
    const target = document.getElementById(id);
    if (target) {
      setTimeout(() => smoothScrollTo(target), 50);
    }
  };

  const hijackAnchorClicks = () => {
    document.addEventListener('click', (e) => {
      const a = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;

      const href = a.getAttribute('href') || '';
      const parts = href.split('#');
      if (parts.length < 2) return;

      const base = parts[0];
      const hash = parts[1];
      if (!hash) return;

      // same-page anchor
      const isSamePage = !base || base === window.location.pathname;
      if (isSamePage) {
        const target = document.getElementById(hash);
        if (target) {
          e.preventDefault();
          smoothScrollTo(target);
        }
      }
    });
  };

  ready(() => {
    applyNavTweaks();
    hideFeeProductCards();
    hijackAnchorClicks();
    handleInitialHash();

    // Re-apply after Shopify sections re-render (theme editor / cart updates)
    document.addEventListener('shopify:section:load', () => {
      applyNavTweaks();
      hideFeeProductCards();
    });
  });
})();
